import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import MemberShipPriceCard from 'components/card/MemberShipPriceCard';
import SubscribeModal from 'components/modal/SubscribeModal';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import DefaultButton from 'components/button/DefaultButton';
import { useAtomValue, useSetAtom } from 'jotai';
import modalInformationAtom from 'atom/modalInformationAtom';
import useCalculateTotalPriceForAllMemberships from 'hooks/useCalculateTotalPriceForAllMemberships';
import useCalculateMembershipTotalPrice from 'hooks/useCalculateMembershipTotalPrice';
import useRemoveFromCart from 'hooks/useRemoveFromCart';
import useChangeMebershipCount from 'hooks/useChangeMebershipCount';
import userInforAtom from 'atom/userInfoAtom';
import companyInforAtom from 'atom/companyInfoAtom';
import { useMutation } from '@tanstack/react-query';
import { freeOrderCart } from 'apis/PayApi';

interface SubscribeHistoryLayoutProps {
  cartData: MemberShipDataTypes[];
  setCartData: React.Dispatch<React.SetStateAction<MemberShipDataTypes[]>>;
}

export type Action = 'increment' | 'decrement';

type FreeCheck = 'free' | 'error' | 'normal';

type MembershipDataToParams = {
  count: number;
  info: {
    ebticketidx: number;
    division: number[];
    price: string;
    subscribetype: number;
    subscribeid: string;
    licenseidx: number;
  };
};

const SubscribeHistoryLayout = ({ cartData, setCartData }: SubscribeHistoryLayoutProps) => {
  const [openSubScribeModal, setOpenSubScribeModal] = useState(false);
  const [checkListInFree, setCheckListInFree] = useState<FreeCheck>('normal');

  const userInfor = useAtomValue(userInforAtom);
  const companyInfor = useAtomValue(companyInforAtom);
  const setModalInformation = useSetAtom(modalInformationAtom);

  const handleClickOpenSubScribeModal = () => {
    if (checkListInFree === 'normal') {
      setOpenSubScribeModal(true);
    } else if (checkListInFree === 'error') {
      setModalInformation({
        type: 'CHECK_FREE'
      });
    } else {
      setModalInformation({
        type: 'SUBSCRIBE_FREE',
        handleClickRightBtn: () => {
          const paymentData = {
            uid: userInfor.uid,
            usridx: userInfor.usridx,
            companyidx: companyInfor.companyidx,
            centeridx: companyInfor.centeridx,
            companyname: companyInfor.companyname,
            countrycode: 'KR',
            termidx: 10,
            agree: 1,
            currency: 'KRW',
            successurl: '',
            cancelurl: '',
            failedurl: '',
            paymenttype: 0, // 무료
            paymentmethod: 0, // 무료
            membershipdata: selectedCardData
          };

          freeOrderSubscribe.mutate(paymentData);
        }
      });
    }
  };

  const freeOrderSubscribe = useMutation({
    mutationFn: (param: any) => freeOrderCart(param),
    onSuccess: (data: any) => {
      if (data.result === 'success') {
        setModalInformation({
          type: 'PAY_SUCCESS',
          handleClickRightBtn: () => {
            window.location.reload();
          }
        });
      } else if (data.result === 'failed') {
        setModalInformation({
          type: 'PAY_CANCEL'
        });
      } else {
        setModalInformation({
          type: 'PAY_CANCEL'
        });
      }
    },
    onError: (error: any) => {}
  });

  const calculateMembershipTotalPrice = useCalculateMembershipTotalPrice();

  const selectedCardData: MembershipDataToParams[] = cartData.map((item: MemberShipDataTypes) => ({
    count: item.count,
    info: {
      ebticketidx: item.ebticketidx,
      division: item.divisiondata
        .filter((division) => !division.hasOwnProperty('recommendyn') || division.recommendyn)
        .map((division) => division.division),
      price: calculateMembershipTotalPrice(item).toString(),
      subscribetype: item.subscribetype,
      subscribeid: '',
      licenseidx: item.licenseData?.licenseidx || 0,
      periodvalue: item.periodvalue || null,
      periodtypeidx: item.periodtypeidx || null
    }
  }));

  // 결제 시 전달해야할 결제정보

  const handleClickCloseSubScribeModal = () => {
    setOpenSubScribeModal(false);
  };

  const memberShipCount = cartData.filter((item) => item.cart).length;

  const handleClickModal = (index: number) => {
    setModalInformation({
      type: 'REMOVE_CART',
      handleClickRightBtn: () => handleClickRemoveFromCart(index)
    });
  };

  const totalPriceForAllMemberships = useCalculateTotalPriceForAllMemberships(cartData);
  const handleClickRemoveFromCart = useRemoveFromCart(cartData, setCartData);
  const handleClickChangeCount = useChangeMebershipCount(cartData, setCartData, handleClickModal);

  useEffect(() => {
    const isFreeTicket = cartData?.some((ticket) => ticket.subscribetype === 5);

    if (isFreeTicket) {
      const hasOtherSubscribetype = cartData?.some((ticket) => ticket.subscribetype !== 5);

      hasOtherSubscribetype ? setCheckListInFree('error') : setCheckListInFree('free');
    } else {
      setCheckListInFree('normal');
    }
  }, [cartData]);

  return (
    <Wrapper>
      <h3>결제 내역</h3>
      <CartWrapper>
        {cartData.map((data, index) => {
          const { ticketnamecustomer: name, count, divisiondata, subscribetype } = data;

          return (
            <MemberShipPriceCard
              key={name + index}
              price={calculateMembershipTotalPrice(data)}
              name={name}
              subscribetype={subscribetype}
              divisiondata={divisiondata}
              handleClickRemoveFromCart={() => handleClickModal(index)}
              handleClickChangeCount={(action: Action) => handleClickChangeCount(index, action)}
              count={count}
              licenseData={data?.licenseData ? true : false}
            />
          );
        })}

        <PriceWrapper>
          <PriceText>최종 결제 정보</PriceText>
          <div>
            <p>멤버십 {memberShipCount}개</p>
            <p>{totalPriceForAllMemberships.toLocaleString()}원</p>
          </div>
        </PriceWrapper>

        <SubmitButtonWrapper>
          <DefaultButton
            text="구독하기"
            onClick={handleClickOpenSubScribeModal}
            type="primary"
            style={{
              width: '100%'
            }}
            disabled={cartData.length < 1}
          />
        </SubmitButtonWrapper>
      </CartWrapper>
      {openSubScribeModal && (
        <SubscribeModal
          open={openSubScribeModal}
          cartData={cartData}
          onCancel={handleClickCloseSubScribeModal}
        />
      )}
    </Wrapper>
  );
};

export default SubscribeHistoryLayout;

const Wrapper = styled.div`
  position: sticky;
  top: 112px;
  height: max-content;
  width: 420px;

  h3 {
    margin-bottom: 32px;
    color: ${color.black2};
    ${font.h2_bold};
  }
`;

const CartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: space-between;
  gap: 8px;
  border-radius: 12px;
  background: ${color.gradientType1};
  color: ${color.black};

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${font.h3_bold};
  }
`;

const PriceText = styled.h5`
  ${font.body_medium};
`;

const SubmitButtonWrapper = styled.div`
  color: ${color.white2};
  ${font.h3_medium};
`;

// const CouponPriceWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: flex-start;
//   padding: 20px;
//   border-radius: 12px;
//   background: ${color.blue50};

//   h4 {
//     display: flex;
//     align-items: center;
//     color: ${color.black2};
//     ${font.h4_bold};
//   }
// `;

// const InnerWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 12px;
//   margin-left: auto;
// `;

// const TextWrapper = styled.div`
//   display: flex;
//   gap: 8px;
// `;

// const CouponPrice = styled.div`
//   color: ${color.black2};
//   width: 100%;
//   text-align: right;
//   ${font.h3_bold};
// `;
